<template>
    <PopupRouterView :showLeftIcon="true" label="Repair Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="repair"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="repairInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-control-card" ref="fieldset-control-card" :model.sync="controlCardQrCode" label="Control Card" @scannedMethod="scanControlCard" :isBusy="isScanControlCardLoading" @focus.once="getControlCards()" autofocus/>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="controlCards != null && controlCards.length > 0">
							<app-list :isDataLoading="isControlCardControlCardsLoading" :dataCount="controlCards.length">
								<control-card-item v-for="(item,index) in controlCards" :model="item" :key="index" @nextAction="goToNext(1, item)" :isDisabled="checkIsControlCardDisabled(item)"/>
							</app-list>
						</span>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox label-cols-lg="12" label="Control Card" label-for="label-repair-control-card-number" :model="(model.controlCard != null) ? model.controlCard.controlCardNumber : null" id="label-repair-control-card-number"
						:isEditable="false"/>
						<app-input-textbox label-cols-lg="12" label="Qty Case" label-for="label-repair-control-card-qtycase" :model="(model.controlCard != null) ? model.controlCard.qtyCase : null" type="number" id="label-repair-control-card-qtycase"
						 :isEditable="false"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox label-cols-lg="12" label="Part Number" label-for="label-repair-control-card-part-number" :model="(model.controlCard != null && model.controlCard.part != null) ? model.controlCard.part.partNumber : null" id="label-repair-control-card-part-number"
						 :isEditable="false"/>
						 <app-input-textbox label-cols-lg="12" label="Part Name" label-for="label-repair-control-card-part-name" :model="(model.controlCard != null && model.controlCard.part != null) ? model.controlCard.part.partName : null" id="label-repair-control-card-part-name"
						 :isEditable="false"/>
					</b-col>
					<b-col cols="12" class="mt-5">
						<!-- <app-input-textbox id="fieldset-case-qty" label-cols-lg="12" label="Case Qty" label-for="input-case-qty" size="sm" :model.sync="model.caseQty"   /> -->
						<app-input-textbox id="fieldset-qty-ok" label-cols-lg="12" label="Qty OK" label-for="input-qty-ok" size="sm" :model.sync="model.qtyOk"  type="number" />
						<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12" label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="model.qtyNg"  type="number" />

					</b-col>
				</b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-default float-right" @click="$router.back()">Cancel</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-default float-right" @click="goToNext(0)">Cancel</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="saveScanControlCard()">Save</b-button>
        </template>

    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import Repair from '@/models/Repair/Repair';
import RepairList from '@/models/Repair/RepairList';
import RepairFilter from '@/filters/Repair/RepairFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppLabel from '@/components/AppLabel';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
import ControlCardItem from './components/ControlCardItem';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		PopupRouterView,
		AppInputScan,
		AppList,
		ControlCardItem,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterRepair : null,
			currentRepairPage : 1,
			repairPageSize: 10,
			sortByRepair: '',
			sortDescRepair: '',
			controlCards: [],
			isControlCardComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			controlCardQrCode: '',
			isScanControlCardLoading: false,
			isControlCardControlCardsLoading: false,
		}
	},
	methods : {
		getRepair : async function(id) {
			this.isBusy = true;
			Repair.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				if(this.model.controlCardId != null) {
					promises.push(
						this.getControlCard(this.model.controlCardId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadRepair = true;
			this.filterRepair.id = this.modelId;
			Repair.downloadDataDetail(this, this.filterRepair).then(result => {
				this.isDownloadRepair = false;
			}).catch(error => { this.isDownloadRepair = false; })
		},
		getRepairs : async function(input) {
			let filter = new RepairFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isRepairComboLoading = true;
			await Repair.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.repairs = result.data
				}
				this.isRepairComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let this_ = this;
			this_.controlCards = [];
			let filter = new ControlCardFilter();
			filter.controlCardNumber = input;
			// filter.exactType.controlCardNumber = 1;
			filter.controlCardStatusId = 'PENDING';
			await ControlCard.getList(this_, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this_.controlCards = result.data
				}
			})
			.catch(error => {
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
						});
					});
				}
				this_.controlCards = [];
				this_.controlCardQrCode = '';
				return;
			});
		},
		getControlCardsEqual : async function(input) {
			let this_ = this;
			this_.controlCards = [];
			let filter = new ControlCardFilter();
			filter.controlCardNumber = input;
			filter.exactType.controlCardNumber = 1;
			//filter.controlCardStatusId = 'PENDING';
			await ControlCard.getList(this_, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this_.controlCards = result.data;
				}
			})
			.catch(error => {
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
						});
					});
				}
				this_.controlCards = [];
				this_.controlCardQrCode = '';
				return;
			});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCard : async function(id) {
			ControlCard.getData(this, id).then(result => {
				this.model.controlCard = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.repairInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						Repair.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'repairindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						Repair.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'repairindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return Repair.updateData(this, model, id)
					.catch((error) => {
						return this.getRepair(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getRepairs();
		},
		resetModal(modalType) {
			this.controlCardQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		async scanControlCard() {
			this.isBusy = true;
			let qrCode = encodeURIComponent(this.controlCardQrCode);
			let id = this.model.id;
			let this_ = this;
			delete this_.model.id;

			if (qrCode == undefined || qrCode == null || qrCode == '') {
				return;
			}

			if (qrCode != this.controlCards[0]) {
				await this.getControlCardsEqual(qrCode);
				let scanControlCard = this.controlCards[0];
				if (scanControlCard == undefined || scanControlCard == null) {
					this_.toast({message: 'Control Card Number tidak ditemukan di database', title: 'Message', variant: 'warning'});
					this_.controlCardQrCode = '';
					this_.isBusy = false;
					return;
				}
			}else{
				await this.getControlCards(qrCode);
				let scanControlCard = this.controlCards[0];
				if (scanControlCard == undefined || scanControlCard == null) { 
					this_.toast({message: 'Control Card Number tidak ditemukan di database', title: 'Message', variant: 'warning'});
					this_.controlCardQrCode = '';
					this_.isBusy = false;
					return;
				}
			}

			let scanControlCard = this.controlCards[0];

			this.$http.get('Repair/scanControlCard/' + scanControlCard.id)
			.then(async function(response){
				this_.isBusy = false;
				this_.goToNext(2, scanControlCard);
			})
			.catch(function(error){
				this_.controlCards = [];
				this_.controlCardQrCode = '';
				this_.isBusy = false;
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
						});
					});
				}
				return;
			});
		},
		async saveScanControlCard() {
			let this_ = this;
			this_.isBusy = true;
			let data = this.model;
			this_.$http.post('Repair/saveScanControlCard/', data)
			.then(async function(response){
				this_.isDataCommited = true;
				this_.$router.push({ name: 'repairindex' });
				this_.isBusy = false;
			})
			.catch(function(error){
				this_.isBusy = false;
				if (error.response && error.response.data && error.response.data.errors) {
					const errors = error.response.data.errors;
					// Iterasi melalui setiap pesan kesalahan
					Object.keys(errors).forEach(key => {
						const errorMessages = errors[key];
						errorMessages.forEach(errorMessage => {
							// Tampilkan pesan kesalahan dalam toast
							this_.toast({message: errorMessage, title: 'Error', variant: 'danger'});
						});
					});
				}
				return;
			});;
		},
		checkIsControlCardDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		goToNext(page, item) {
			if (page == 1) {
				this.controlCardQrCode = item.controlCardNumber;
				this.scanControlCard();
			}

			if (page == 2) {
				this.model.controlCard = item;
				this.model.controlCardId = item.id;
				this.scanPageIndex = page;
				return;
			}

			if (page == 0) {
				this.controlCardQrCode = '';
				this.model.qtyOk = '';
				this.model.qtyNg = '';
				this.scanPageIndex = 1;
			}
		},
	},
	beforeMount() {
		this.filterRepair = new RepairFilter();
		//this.getControlCards();
	},
	async mounted(){
		let id = this.$route.params.id;

		this.getControlCards();
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getRepair(id);
		}
		this.$nextTick(() => {
			
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		controlCardQrCode(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getControlCards(newValue);
			} else {
				this.getControlCards();
			}
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
